{
  "name": "car-rainbow",
  "version": "1.14.2",
  "description": "A road-trip game for kids: spot a real car of each rainbow color and check it off — free and built for the back seat.",
  "source": "src/index.html",
  "scripts": {
    "build": "parcel build",
    "start": "parcel",
    "test": "playwright test",
    "test:update-snapshots": "playwright test --update-snapshots",
    "test:unit": "vitest run",
    "test:unit:watch": "vitest"
  },
  "author": "",
  "license": "ISC",
  "devDependencies": {
    "@parcel/transformer-sass": "^2.16.4",
    "@playwright/test": "^1.60.0",
    "@testing-library/jest-dom": "^6.9.1",
    "@testing-library/react": "^16.3.2",
    "@testing-library/user-event": "^14.6.1",
    "jsdom": "^28.1.0",
    "parcel": "^2.16.4",
    "process": "^0.11.10",
    "vitest": "^4.1.8"
  },
  "dependencies": {
    "react": "^19.2.7",
    "react-dom": "^19.2.7"
  }
}
